import OrderTaker from '../branch/services-management/order-taker-management';

function InhouseOrdering() {
  return <OrderTaker type="CUSTOMER" />;
}

export default InhouseOrdering;
